import { Box } from '@material-ui/core';
import PrimaryButton from 'common/components/buttons/primaryButton';
import { InputLabelOutlined } from 'common/components/fields/fields';
import GeneralGrid from 'common/components/layout/grid/GeneralGrid';
import LoadingProgress from 'common/components/progress/loading';
import SecondaryButton from 'common/components/buttons/secondaryButton';
import { Alert } from '@mui/material';
import _ from 'lodash';
import NewSelectMultiple from 'common/components/fields/NewSelectMultiple';
import { create_or_update, setFormValue } from 'helpers/formComponent';
import React, { useEffect } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import { getStationActiveActions } from '../actions/activeActions/activeActionsScripts';
import {
  create,
  getDetail,
  initializeForm,
  setDetail,
  setLoading,
  update,
} from './validatorsActions';

let ValidatorCodeForm = function(props) {
  const { validatorCode, router, location, getDetail, setDetail, activeActions } = props;
  const partner_id = props.auth.user.establishments?.[0]?.id;
  const opcoesActions = activeActions.list.map((it) => ({ id: it.id, title: `${it.station?.name}: ${it.name}` }));
  const hasSelectedActions = props.formValues?.actions?.length > 0;
  // console.log(opcoesActions, activeActions.list);

  useEffect(() => {
    if (!router.params.id) {
      props.setLoading(false);
    } else {
      setFormValue(validatorCode, router, location, getDetail, setDetail);
    }
    if (_.isEmpty(props.activeActions.list) && partner_id) {
      props.getStationActiveActions(partner_id);
    }
  }, []);

  function onSubmit(values) {
    const { create, update } = props;
    const actions = values.actions || [];

    const newValues = {
      ...values,
      partner_id: partner_id,
      actions,
    };

    create_or_update(router, newValues, create, update);
  }

  return props.validatorCode.loading ? (
    <Box display="flex" height="100vh" justifyContent="center" mt={10}>
      <LoadingProgress />
    </Box>
  ) : (
    <section
      id="validatorCode-form"
      style={{ paddingBottom: isMobileOnly ? 100 : 0 }}
    >
      <GeneralGrid container spacing={3}>
        <GeneralGrid item xs={12}>
          <div className="card">
            <div className="card-body">
              <p className=" h4 card-title text-muted">Validadores</p>
              <GeneralGrid item xs={12} style={{ marginTop: '16px' }}>
                <Alert
                  severity={hasSelectedActions ? 'info' : 'warning'}
                  style={{ marginBottom: '16px' }}>
                  {hasSelectedActions
                    ? 'Apenas as atividades selecionadas poderão ser validadas por este validador.'
                    : 'Caso nenhuma atividade seja selecionada, o validador estará apto a validar qualquer atividade da estação.'}
                </Alert>
              </GeneralGrid>
              <Form
                role="form"
                onSubmit={props.handleSubmit(onSubmit)}
                noValidate
              >
                <GeneralGrid container spacing={3}>
                  <GeneralGrid item xs={12}>
                    <Field
                      component={InputLabelOutlined}
                      label="Identificação (nome, matrícula, ID)"
                      name="identification"
                      required
                      margin="normal"
                    />
                  </GeneralGrid>
                </GeneralGrid>
                <GeneralGrid item xs={12} md={6}>
                  <GeneralGrid item xs={12}>
                    <Field
                      component={InputLabelOutlined}
                      label="Código"
                      name="code"
                      required
                      margin="normal"
                    />
                  </GeneralGrid>
                </GeneralGrid>

                <GeneralGrid container spacing={3}>
                  <GeneralGrid item xs={12}>
                    <Field
                      component={NewSelectMultiple}
                      label={'Selecione as atividades'}
                      options={opcoesActions}
                      name="actions"
                      margin="normal"
                    />
                  </GeneralGrid>
                </GeneralGrid>

                <GeneralGrid
                  container
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  style={{ marginTop: 32 }}
                >
                <SecondaryButton
                  onClick={() => props.router.push('/owner/validadores')}
                  color="primary">
                  Cancelar
                </SecondaryButton>
                  <PrimaryButton
                    type="submit"
                    disabled={props.validatorCode.buttonLoading}
                    progress={parseInt(props.general.submitProgress)}
                  >
                    {props.validatorCode.buttonLoading
                      ? 'Salvando'
                      : 'Salvar'}
                  </PrimaryButton>
                </GeneralGrid>
              </Form>
            </div>
          </div>
        </GeneralGrid>
      </GeneralGrid>
    </section>
  );
};

ValidatorCodeForm = reduxForm({ form: 'validatorCodeForm' })(ValidatorCodeForm);

const mapStateToProps = state => {
  return {
    auth: state.auth,
    validatorCode: state.validatorCode,
    activeActions: state.activeActions,
    formValues: getFormValues('validatorCodeForm')(state),
    general: state.general,
  };
};
const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      getDetail,
      setDetail,
      initializeForm,
      create,
      update,
      getStationActiveActions,
      setLoading,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ValidatorCodeForm);
